export default {

    //layout
    sRadius: 3,

    sCardPadding: 20,

    //font
    sFontRegular: 16,
    sFontBig: 18,
    sFontButton: 13,
    sFontMicro: 12,
    sFontHuge: 24,

    sIcon: 26,
    sIconBig: 78,

    sInput: 44,


    //color
    cWhite: '#ffffff',
    cBlack: '#000000',
    cText: '#445363',
    cTheme: '#ED6B42',
    cThemeActive: '#d66341',
    cAccent: '#4881C6',
    cAccentActive: '#3f6ca8',
    cMicrocopyText: '#99ABC0',
    cBorder: '#445363',
    cBorderLight: '#BDCCD2',
    cWrong: '#CE2525',
    cBg: '#f0f0f0',
    cCard: '#EDEFF1',
    cFrameBg: '#F3F3F3',

    //time
    tGeneric: 0.2,

    //timing functions
    tfStandard: 'cubic-bezier(0.4, 0.0, 0.2, 1)',


    zAbove: 200,
    zMenu: 300,
    zAboveMenu: 400,
    zModal: 500,

    //typography
    sH1: 70,
    sH2: 45,
    sH3: 36,
    sH4: 22,

    //grid

    sm: 540,
    md: 720,
    lg: 960,
    xl: 1140,

    breakpoints: {
        xs: 576,
        sm: 768,
        md: 992,
        lg: 1200,
    },
};